import { Campaign, NationalCampaign } from '@domain/campaign';
import { createContext, useState, useEffect } from 'react';
import { useRouter } from 'next/router';
import { Event } from '@components/calendar';

export type CampaignContextType = {
  storedCampaign: NationalCampaign | Campaign;
  setStoredCampaign: (data: NationalCampaign | Campaign) => void;
  isWithinBoundry: unknown;
  setIsWithinBoundry: (data: unknown) => void;
  selectedEvent: Event;
  setSelectedEvent: (event: Event) => void;
  areaLarge: unknown;
  setAreaLarge: (areaLarge: unknown) => void;
};

export type KeyValueType = {
  [key: string]: boolean;
};

export const CampaignContext = createContext<Partial<CampaignContextType>>({});

const CampaignProvider = ({ children }) => {
  const [storedCampaign, setStoredCampaign] = useState<
    NationalCampaign | Campaign
  >();
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);
  const router = useRouter();

  // reset context state based on url
  useEffect(() => {
    if (!router.asPath.includes('/campaigns/create')) {
      setStoredCampaign(null);
    }
  }, [router]);

  const [isWithinBoundry, setIsWithinBoundry] = useState<KeyValueType>({});
  const [areaLarge, setAreaLarge] = useState<KeyValueType>({});
  return (
    <CampaignContext.Provider
      value={{
        storedCampaign,
        isWithinBoundry,
        selectedEvent,
        setSelectedEvent,
        setStoredCampaign,
        areaLarge,
        setIsWithinBoundry,
        setAreaLarge,
      }}>
      {children}
    </CampaignContext.Provider>
  );
};

export default CampaignProvider;
